import { useEffect, useState } from 'react';

export default function useUpdateNotifier() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [newVersionAvailable, setNewVersionAvailable] = useState(false);

  useEffect(() => {
    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('/service-worker.js').then(registration => {
            registration.onupdatefound = () => {
                const installingWorker = registration.installing;
                installingWorker.onstatechange = () => {
                    if (
                    installingWorker.state === 'installed' &&
                    navigator.serviceWorker.controller
                    ) {
                        setWaitingWorker(registration.waiting);
                        setNewVersionAvailable(true);
                    }
                };
            };
        });
        navigator.serviceWorker.register('/firebase-messaging-sw.js')
        .then(function(registration) {
            // console.log("Registered Service Worker ✅", registration);
        })
        .catch(function(err) {
            console.error("Erreur lors de l'enregistrement du SW ❌", err);
        });
    }
  }, []);

  const updateApp = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
      setNewVersionAvailable(false);
    }
  };

  return { newVersionAvailable, setNewVersionAvailable, updateApp };
}
